export default function StockImage({ src, alt = "", aspect = "aspect-[3/4]", className = "" }) {
  return (
    <div
      data-testid="stock-image"
      className={`relative w-full ${aspect} overflow-hidden border border-[#E3DECE] bg-[#F2EFE9] ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover"
      />
    </div>
  );
}
